

import { observer } from 'mobx-react-lite'

import { AppBar, Button, Container, Drawer, Stack } from '@mui/material';

import Icon from "@mdi/react";
import { mdiMicrosoftXboxControllerMenu } from '@mdi/js';

import NavButton from './parts/NavButton'
import LinkIcons from './parts/LinkIcons'

import { useContext } from "react"
import RootContext from '../data/RootStore'


const Header = observer(() => {

  const rc = useContext(RootContext)

  return (
    <>
    { !rc.ui.isNarrow() && 
      <AppBar color="secondary" style={{minHeight:40, backgroundColor:rc.mf.config.color.frame.c}} >
        {rc.ui.curPage === 'Home' && <div style={{ marginTop:5, fontSize: '2em', fontFamily:rc.mf.config.font.super }}>Book the floral experience of your dreams...</div> }
        {rc.ui.curPage !== 'Home' && <div style={{ marginTop: 5,fontSize: '2em', fontFamily:rc.mf.config.font.super }}>Moda Floral</div> }
        <div onClick={() => { rc.ui.bumpEdit() }} style={{position:'absolute', right:0, top:0, height:25, width:190}}>          
          { rc.ui.editMode && <div style={{backgroundColor:'red',borderRadius:10,padding:3, margin:5, userSelect:'none'}} >&nbsp;EDIT MODE</div> }
        </div>
      </AppBar>
    }
    </>
  )
})


export default Header;
